import { createContext } from 'react'
import { FlowManager } from '../types'

export const FlowManagerContext = createContext<FlowManager>(null)
